export default "__VITE_ASSET__Bv5jCu8R__"